<template>
  <Grid gtc="1.5fr 1fr" gap="var(--r-space-md) var(--r-space-sp)">
    <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
      <TodoList
        :component="{ type: 'to-do-list' }"
        :context-url="`/product/${id}`"
        title="Tasks"
        from-page="product"
        @uncompleted-count="updateUncompletedTodos"
      />

      <Notes :entity="{ name: 'product', id }" :fill-vertical-space="true" store-namespace="products" />
    </Grid>

    <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
      <Attachments :entity="{ name: 'product', id }" store-namespace="products" />
      <Links :dropdown-initial-value="linksCategories" :entity="{ name: 'product', id }" store-namespace="products" />
    </Grid>
  </Grid>
</template>

<script>
import { linksCategories } from '@/reusable/data/links-categories'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Libraries
import { mapState, mapMutations } from 'vuex'
// Components
import Notes from '@components/lm-blocks/Notes'
import Links from '@components/lm-blocks/Links'
import Attachments from '@components/lm-blocks/Attachments'
import TodoList from '@/components/general/ToDoList/ToDoList'

export default {
  components: {
    Notes,
    Links,
    Attachments,
    TodoList
  },

  mixins: [registerVuexModule('todo-modal', () => require('@/reusable/TodoModal/vuex/TodoModal'))],

  props: {
    id: [Number, String] // from route
  },

  computed: {
    ...mapState('product-show', ['product']),
    linksCategories
  },

  watch: {
    product: {
      handler(val) {
        val && this.setEntityForTodo(val)
      },
      immediate: true
    }
  },

  methods: {
    ...mapMutations('todo-modal', ['resetCreateData', 'setEntityForTodo']),
    ...mapMutations('product-show', ['updateUncompletedTodos'])
  }
}
</script>
